module.exports = __webpack_public_path__ + "static/media/achievement-bitter-not-sweet.573d9b81.svg";